import { Animation } from '@ionic/core';
import { growY } from '../../../../utils/animations';

export function treeNodeOpenAnimation(elements: { node: HTMLElement; child: HTMLElement }): Animation {
  const { child } = elements;
  child.style.display = 'block';
  const height = child.offsetHeight;
  child.style.display = '';
  return (growY({ from: '0px', to: `${height}px` }) as Animation).addElement(child);
}
